import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './ActionCondition.view.html';
let ActionConditionComponent = class ActionConditionComponent {
    //#endregion
    constructor() { }
};
ActionConditionComponent = __decorate([
    Component({
        template,
        bindings: {
            action: '=',
            state: '=',
            application: '<',
            isActionConditionEnabled: '<',
            save: '&',
            createCondition: '&',
            removeCondition: '=',
            overLimit: '<',
            titleText: '@',
            infoText: '@',
            addButtonText: '@',
        },
    }),
    __metadata("design:paramtypes", [])
], ActionConditionComponent);
export { ActionConditionComponent };
